import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

const TableColumnTooltip = ({ text }) =>
  <Tooltip title={text}>
    <span>
      {text}
    </span>
  </Tooltip>;

TableColumnTooltip.propTypes = {
  text: PropTypes.string.isRequired
};

export default TableColumnTooltip;
